import type { AnalyticsData, AnalyticsEvent, Group } from "../types";

export function webEvent(group: Group, event: string, data?: AnalyticsData): AnalyticsEvent {
  return { event: `web.${group}.${event}`, ...data };
}
